/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from "react";
import {
  withStyles,
  createTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import { screen_roles } from "./configs/Roles/roles_config";

import axios from "axios";

import {
  Route,
  withRouter,
  Redirect,
  BrowserRouter,
  HashRouter,
  Switch as RouterSwitch,
} from "react-router-dom";
import AppToolBar from "./fluid/Utilities/AppToolBar";
import { connect } from "react-redux";
import { Grid } from "@material-ui/core/Grid";

import routes from './configs/screens/routes'

import screens from "./configs/screens/screens";

import { CircularProgress, Paper, Typography } from '@material-ui/core'

import Screen from "./traditional/Screen";
import Home from './traditional/Home/Home'
import ICList from "./traditional/IC/ICList";
import CreateIC from "./traditional/CreateIC/CreateIC";
import WorldViewServerList from "./traditional/WVServer/WorldViewServerList";
import WebServiceList from "./traditional/WebService/WebServiceList";
import DataRenderingServicesList from "./traditional/DRL/DataRenderingServiceList";
import ICDashboard from "./traditional/Analytics/Screens/ICDashboard";
import Recommendation from "./traditional/Recommendation/Recommendation";
import CognitiveSearch from "./traditional/CognitiveSearch/new/CognitiveSearch";
import ThemeDistribution from "./traditional/ThemeDistribution/new/ThemeDistribution";
import Login from "./traditional/Login/Login";
import TestScreen from "./traditional/TestScreen/TestScreen";
import BotStats from "./traditional/Analytics/Screens/BotStats";
import WFList from "./traditional/Workflow/WFList";
import CreateWorkflow from "./traditional/CreateWorkflow/AddWorkflow";
import Scheduler from "./traditional/Scheduler/CronScheduler";
//import UserList from "./traditional/UserController/UserList";
import UserManagement from './traditional/UserManagement'
import Queue from "./traditional/Queue/Queue";
import Events from "./traditional/Events/Events";
import ScriptsList from "./traditional/Scripts/ScriptsList";
import Dedup from './traditional/Dedup/Dedup'
import UIConfig from './traditional/UIConfig/UIConfig'
import IFC from './traditional/IFC/IFC'
import IRC from './traditional/IRC/IRC'
import Prevent from "./traditional/DQM/Prevent";
import PII from "./traditional/PII/PII"
import SignOut from './traditional/SignOut/SignOut'
import LinkedScreen from "./traditional/LinkedScreens/LinkedScreen";
import ProxyScreen from "./traditional/ProxyScreen/ProxyScreen";

import MtoTConfigScreen from './traditional/DashboardCanvas/MtoTConfigScreen'
import MtoTDashboard from "./traditional/DashboardCanvas/MtoTDashboard";

import FlexForm from "./traditional/FlexForm/FlexForm";
import CSVViewer from "./traditional/Results/components/FileViewers/TABLE/CSV/CSVViewer";
import TextFileViewer from "./traditional/Results/components/FileViewers/TEXT/TextFileViewer";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faBracketsCurly,
  faEnvelopeOpenText,
  faTicketAlt,
  faUserHeadset,
  faFilePdf,
  faCopy,
  faFileWord,
  faFilePowerpoint,
  faFileExcel,
  faFileCsv,
  faFileCode,
  faFileAlt,
  faDatabase,
  faFile,
  faFileSpreadsheet,
  faRobot,
  faTerminal,
  faSnooze,
  faChartNetwork,
  faMicrochip,
  faImage,
  faHourglassEnd,
  faThumbtack
} from "@fortawesome/pro-duotone-svg-icons";
import Actions from "./fluid/Actions/ActionFactory.js";
import About from "./../src/traditional/About/About";
import Settings from "./../src/traditional/Settings/Settings";

import {
  loadAuthToken,
  saveLoggedInUserInfo,
  loadLoggedInUserInfo,
} from "./state_management/localStorage";
import PageNotFound from "./traditional/Utilities/PageNotFound";
import PageNotAuthorized from "./traditional/Utilities/PageNotAuthorized";

import snow_config from "./traditional/Queue/configs/SNow";
import scloud_config from "./traditional/Queue/configs/SCloud";
import VerifyingAccess from "./traditional/Utilities/VerifyingAccess";
import SecurityAdaptorsList from "./traditional/SecurityAdaptors/SecurityAdaptorsList";

import DQMDashboard from "./traditional/Dashboard/DQM/DQMDashboard";
import DQMConfigurator from "./traditional/Dashboard/DQM/config/DQMConfigurator";

import logo from './assets/sainapse_logo2_white.png'

import queryString from 'query-string'

import { HTML5Backend } from 'react-dnd-html5-backend'
import { DndProvider } from 'react-dnd'

library.add(
  faBracketsCurly,
  faEnvelopeOpenText,
  faTicketAlt,
  faUserHeadset,
  faFilePdf,
  faCopy,
  faFileWord,
  faFilePowerpoint,
  faFileExcel,
  faFileCsv,
  faFileCode,
  faFileAlt,
  faDatabase,
  faFile,
  faFileSpreadsheet,
  faRobot,
  faTerminal,
  faSnooze,
  faChartNetwork,
  faMicrochip,
  faImage,
  faHourglassEnd,
  faThumbtack
);

const Screens = {
  home : Home,
  ic_list: ICList,
  create_ic: CreateIC,
  wv_list: WorldViewServerList,
  ws_list: WebServiceList,
  drl_list: DataRenderingServicesList,
  users: UserManagement,
  ic_dashboard: ICDashboard,
  reco: Recommendation,
  search: CognitiveSearch,
  test: TestScreen,
  theme_distribution: ThemeDistribution,
  bot_stats: BotStats,
  workflows: WFList,
  create_workflow: CreateWorkflow,
  snow_flow: Queue,
  scloud_flow: Queue,
  queue : Queue,
  events: Events,
  scripts: ScriptsList,
  settings: Settings,
  about: About,
  dedup : Dedup,
  ifc : IFC,
  irc : IRC,
  pii : PII,
  security_adaptors_list: SecurityAdaptorsList,
  uiconfig : UIConfig,
  dashboard_config : MtoTConfigScreen,
  dashboard_stats : MtoTDashboard,
  link : LinkedScreen,
  proxy : ProxyScreen,
  prevent : Prevent,
  dqm_dashboard : DQMDashboard,
  dqm_dashboard_config : DQMConfigurator
};

const isAuthorized = (rolesAllowed, loggedInUserRoles) => {
  //if any one of logged in user roles are ther in roles allowed , he is authorized
  try {
    for (let i = 0; i < loggedInUserRoles.length; i++) {
      if (rolesAllowed.includes(loggedInUserRoles[i])) {
        return true;
      }
    }
    return true;
  } catch (err) {
    return true;
  }
};

const blue_theme = createTheme({
  palette: {
    primary: {
      main: "#2296f3",
    },
    secondary: {
      main: "#dc014e",
    },
  },
});
class App extends Component {
  state = {
    isLoggedInVerifacationComplete: false,
    invalidCredentials: false,
    invalidCredentialsErrorMessage : "",
    user_info_loaded : false,
    routes_loaded : false,
    routes_loading : false,
    app_ready : false,
    token_verified : false,
    token_verification_failes : false,
    login_from : null,
    token_error : false,
    token_error_message : null
  };

  componentWillMount() {
    let window_url = window.location.href
    console.log("App Query Params Url: ", window_url)
    let query_params_string = window_url.split("?")
    console.log("App Query Params String: ", query_params_string[1])
    let query_params = queryString.parse(query_params_string[1])
    console.log("App Query Params : ", query_params)
    let query_param_keys = Object.keys(query_params)
    let user_corr_id = ""

    if (query_param_keys.includes("userCorrId")) {
      user_corr_id = query_params.userCorrId
    }

    this.setState({...this.state, 
      routes_loaded : false,
      routes_loading : false,
      token_verified : false,
      token_error : false,
      token_error_message : null
    }, () => {
      console.log("Tracking App Entry : Beginning Check For: ", window.location.href)
      if (user_corr_id !== "") {
        console.log("Tracking App Entry : Querying token with userCorrId")
        Actions('http_request', {
          url : "/sainapse/token",
          method : "POST",
          data : {
            tokenDetail : {
              userCorrId: user_corr_id,
              currentUrlContext: "",
              ssoRedirectUri: "",
              token: ""
            }
          }
        }).then(res => {
          localStorage.setItem('logout_uri', res.data.result.tokenDetail.ssoLogoutUri)
          this.props.dispatch({
            type: "UPDATE_AUTH_TOKEN",
            payload: res.data.result.tokenDetail.token,
          });
  
          let user_object = {
            email : res.data.result.userDetail.user.email
          }
  
          this.props.dispatch({
            type: "UPDATE_LOGGED_IN_USER_INFO",
            payload: user_object,
          });
  
          sessionStorage.setItem('user_privileges', JSON.stringify(res.data.result.userDetail.userPrivileges))
          console.log("Tracking App Entry : Is HREF and Last URL Same ? ", window.location.href !== localStorage.getItem("last_visited_url"))
          if (window.location.href !== localStorage.getItem("last_visited_url")) {
            console.log("Tracking App Entry : Loading Last Visited Url from :", window.location.href)
            window.open(localStorage.getItem("last_visited_url"), "_self")
            this.setState({...this.state, token_verified : true}, () => {
              if (this.getUserPreference(JSON.parse(localStorage.getItem('logged_in_user_info'))) === null) {
                console.log("User Preferences Key Missing")
                this.createUserPreferences()
              } else if (this.getUserPreference(JSON.parse(localStorage.getItem('logged_in_user_info'))) === undefined) {
                console.log("User Preference for this user missing")
                this.createUserPreference(JSON.parse(localStorage.getItem('logged_in_user_info')))
              }
            })
          } else {
            console.log("Tracking App Entry : Allowing entry for : ", window.location.href)
            this.setState({...this.state, token_verified : true}, () => {
              if (this.getUserPreference(JSON.parse(localStorage.getItem('logged_in_user_info'))) === null) {
                console.log("User Preferences Key Missing")
                this.createUserPreferences()
              } else if (this.getUserPreference(JSON.parse(localStorage.getItem('logged_in_user_info'))) === undefined) {
                console.log("User Preference for this user missing")
                this.createUserPreference(JSON.parse(localStorage.getItem('logged_in_user_info')))
              }
            })
          }
        }).catch(err => {
          this.setState({...this.state, token_verified : true, token_error : true, token_error_message : err.response.data.message})
        })
      } else {
        console.log("Tracking App Entry : Querying token without userCorrId")
        localStorage.setItem("last_visited_url", window.location.href)
        let auth_token = loadAuthToken()
        Actions('http_request', {
          url : "/sainapse/token",
          method : "POST",
          data : {
            tokenDetail : {
              userCorrId: "",
              currentUrlContext: "",
              ssoRedirectUri: "",
              token: auth_token
            }
          }
        }).then(res => {
          localStorage.setItem("logout_uri", res.data.result.tokenDetail.ssoLogoutUri)
          if (res.data.result.tokenDetail.ssoRedirectUri !== "") {
            window.open(res.data.result.tokenDetail.ssoRedirectUri, "_self")
          } else {
            if (res.data.result.tokenDetail.token === "") {
              this.setState({...this.state, token_verified : true, login_from : 'local'}, () => {
                if (window.location.href !== window.location.origin + "#/login") {
                  window.open(window.location.origin + "#/login", "_self")
                }
              })
            } else {
              this.props.dispatch({
                type: "UPDATE_AUTH_TOKEN",
                payload: res.data.result.tokenDetail.token,
              })
      
              let user_object = {
                email : res.data.result.userDetail.user.email
              }
      
              this.props.dispatch({
                type: "UPDATE_LOGGED_IN_USER_INFO",
                payload: user_object,
              });
      
              sessionStorage.setItem('user_privileges', JSON.stringify(res.data.result.userDetail.userPrivileges))
              console.log("Tracking App Entry : Allow Entry")
              //this.createUserPreferences()
              this.setState({...this.state, token_verified : true}, () => {
                if (this.getUserPreference(JSON.parse(localStorage.getItem('logged_in_user_info'))) === null) {
                  console.log("User Preferences Key Missing")
                  this.createUserPreferences()
                } else if (this.getUserPreference(JSON.parse(localStorage.getItem('logged_in_user_info'))) === undefined) {
                  console.log("User Preference for this user missing")
                  this.createUserPreference(JSON.parse(localStorage.getItem('logged_in_user_info')))
                }
              })
            }
          }
        }).catch(err => {
          this.setState({...this.state, token_verified : true, token_error : true, token_error_message : err.response.data.message})
        })
      }
    })
  }

  componentDidMount() {
    console.log("Routes Loading : ", this.state.routes_loading)
    let user_info = loadLoggedInUserInfo()
    this.createUserPreferences()
    // this.getUserPriveleges()
    if (loadAuthToken() && user_info !== null) {
      this.getUserPriveleges()
    }
  }

  componentDidUpdate (prevProps, prevState) {
    // let user_info = loadLoggedInUserInfo()

    // if (!loadAuthToken() && !user_info) {
    //   if (this.state.routes_loaded || this.state.routes_loading) {
    //     this.setState({...this.state, routes_loaded : false, routes_loading : false})
    //   }
    // }
  }


  createUserPreferences = () => {
    if (localStorage.getItem('user_preferences') === null) {
      let user_preferences = {
        users : []
      }
      localStorage.setItem('user_preferences', JSON.stringify(user_preferences))
      let user_info = loadLoggedInUserInfo()
      console.log("Creating User Preference for User : ", user_info )
      if (loadAuthToken() && user_info !== null) {
        // let user_info = JSON.parse(localStorage.getItem('logged_in_user_info'))
        this.createUserPreference(user_info)
      }
    } 
    // else {
    //   let user_info = loadLoggedInUserInfo()
    //   let user_preferences = JSON.parse(localStorage.getItem('user_preferences'))
    //   // user_preferences.users.map((user, i) => {
    //   //   if (user.preferences.recommendation.settings.ic_view === undefined) {
    //   //     user_preferences.users[i].preferences.recommendation.settings = {...user_preferences.users[i].preferences.recommendation.settings, ic_view : {}}
    //   //   }
    //   // })
    //   let cur_user_index = user_preferences.users.find(user => user.user_id === user_info.email)
    //   if (cur_user_index === -1) {
    //     console.log("Creating User Preference for User : ", user_info )
    //     this.createUserPreference(user_info)
    //   }
    //   // localStorage.setItem('user_preferences', JSON.stringify(user_preferences))
    // }
  }

  createUserPreference = (user_info) => {
    console.log("Creating User Preference: ", user_info)
    let user_preference = {
      user_id : user_info.email,
      preferences : {
        recommendation : {
          settings : {
            group_results : false,
            ic_view : {}
          },
          saved_sort_settings : [],
          saved_filters : []
        }
      }
    }

    let user_preferences = JSON.parse(localStorage.getItem('user_preferences'))
    user_preferences.users.push(user_preference)
    localStorage.setItem('user_preferences', JSON.stringify(user_preferences))
  }

  getUserPreference = (user_info) => {
    if (localStorage.getItem('user_preferences') === null) {
      return null
    } else {
      let user_preferences = JSON.parse(localStorage.getItem('user_preferences'))
      let user_preference = user_preferences.users.find(user => user.user_id === user_info.email)
      if (user_preference === undefined) {
        return undefined
      }
      return user_preference
    }
  }

  getCustomSearchScreens = (routes) => {
    let drawer_routes = routes.drawer
    console.log("Drawer Routes : ", drawer_routes)
    let op_section = drawer_routes.find(section => section.id === 'operations')
    console.log("Operation Section : ", op_section)
    let search_section = op_section.screens.find(section => section.id === 'search')
    console.log("Search Section : ", search_section)
    let custom_search_screens = search_section.screens.filter(screen => screen.name !== 'Search')
    console.log("Custom Screens : ", custom_search_screens)
    // let fixed_custom_search_screens = custom_search_screens.map(screen => {
    //   let L1_role_index = screen.roles.findIndex(role => role === 'ROLE_L1_USER')
    //   console.log("L1 User Index : ", L1_role_index)
    //   if (L1_role_index !== -1) {
    //     screen.roles[L1_role_index] = 'ROLE_L1'
    //   }
    //   return screen
    // })
    return custom_search_screens
  }

  getCaseScreens = (routes) => {
    let drawer_routes = routes.drawer
    let case_section = drawer_routes.find(section => section.id === 'cases')
    let case_screens = case_section.screens
    // let fixed_case_screens = case_screens.map(screen => {
    //   let L1_role_index = screen.roles.findIndex(role => role === 'ROLE_L1_USER')
    //   console.log("L1 User Index : ", L1_role_index)
    //   if (L1_role_index !== -1) {
    //     screen.roles[L1_role_index] = 'ROLE_L1'
    //   }
    //   return screen
    // })

    // return fixed_case_screens
    return case_screens
  }

  getLinkedScreens = (routes) => {
    let drawer_routes = routes.drawer
    let links_section = drawer_routes.find(section => section.id === 'links')
    return links_section.screens
  }

  getUserPriveleges = (chained_func) => {
    const userInfo = loadLoggedInUserInfo()
    if (!sessionStorage.getItem('user_privileges')) {
      Actions('http_request', {
        url : "/sainapse/users/" + userInfo.email  + "/privileges",
        method : "get",
        data : {}
      }).then(res => {
        sessionStorage.setItem('user_privileges', JSON.stringify(res.data.result))
        if (chained_func) {
          chained_func()
        }
      }).catch(err => {
        
      })
    } else {
      if (chained_func) {
        chained_func()
      }
    }
  }

  getRoutes = () => {
    if (this.state.routes_loading === false) {
      this.setState({...this.state, routes_loading : true}, () => {
        Actions('http_request', {
          url : "/sainapse/configuration/ui_routes",
          method : "get",
          data : {}
        }).then(res => {
          let template_version = routes.version
          console.log("UI Routes Version : Template :: ", template_version)
          let saved_routes_version = res.data.result.config.version
          console.log("UI Routes Version : MW :: ", res.data.result.config.version)
          if (saved_routes_version < template_version) {
            console.log("UI Routes is older than template.")
            let saved_routes = res.data.result.config
            let new_routes = routes
            let custom_search_screens = []
            try {
              custom_search_screens = this.getCustomSearchScreens(saved_routes)
              console.log("UI Routes :: Custom Search Screens : ", custom_search_screens)
            } catch (err) {
              console.log("UI Routes Error :: Error getting custom search screens")
            }
            
            let fixed_case_screens = []
            try {
              fixed_case_screens = this.getCaseScreens(saved_routes)
              console.log("UI Routes :: Fixed Case Screens : ", fixed_case_screens)
            } catch (err) {
              console.log("UI Routes Error :: Error getting fixed screens")
            }
            
            let linked_screens = []
            try {
              linked_screens = this.getLinkedScreens(saved_routes)
              console.log("UI Routes :: Linked Screens : ", fixed_case_screens)
            } catch(err) {
              console.log("UI Routes Error :: Error getting linked screens")
            }
            
            let op_section = new_routes.drawer.find(section => section.id === 'operations')
            let search_section = op_section.screens.find(section => section.name === 'Cognitive Search')
            search_section.screens.push(...custom_search_screens)
            let case_section = new_routes.drawer.find(section => section.id === 'cases')
            case_section.screens = fixed_case_screens
            let linked_section = new_routes.drawer.find(section => section.id === 'links')
            linked_section.screens = linked_screens
            console.log("New Routes : ", new_routes)
            Actions('http_request', {
              url : "/sainapse/configuration/ui_routes",
              method : "put",
              data : {
                config : new_routes
              }
            }).then(result => {
              console.log("UI Routes new version pushed : ", result)
              sessionStorage.setItem('ui_routes', JSON.stringify(result.data.result.config))
              this.setState({...this.state, routes_loading : false, routes_loaded : true})
            })
          } else {
            console.log("Template and UI Routes are same version.", res.data.result.config)
            sessionStorage.setItem('ui_routes', JSON.stringify(res.data.result.config))
            this.setState({...this.state, routes_loading : false, routes_loaded : true})
          }
        }).catch(err => {
          if (err.response) {
            if (err.response.status === 403) {
              //localStorage.clear();
              sessionStorage.clear()
              this.props.dispatch({
                type: "UPDATE_LOGGED_IN_USER_INFO",
                payload: null,
              })
  
              this.props.dispatch({
                type: "UPDATE_AUTH_TOKEN",
                payload: null,
              })
              this.setState({...this.state, routes_loading : false, routes_loaded : false})
              this.props.history.push("/login")
            } else {
              Actions('http_request', {
                url : "/sainapse/configuration/",
                method : "post",
                data : {
                  name : "ui_routes",
                  config : routes
                }
              }).then(res => {
                Actions('http_request', {
                  url : "/sainapse/configuration/ui_routes",
                  method : "get",
                  data : {}
                }).then(res => {
                  sessionStorage.setItem('ui_routes', JSON.stringify(res.data.result.config))
                  this.setState({...this.state, routes_loading : false, routes_loaded : true})
                }).catch(err => {
                  sessionStorage.setItem('ui_routes', null)
                  this.setState({...this.state, routes_loading : false, routes_loaded : false})
                })
              })
            }
          } else {
            Actions('http_request', {
              url : "/sainapse/configuration/ui_routes",
              method : "put",
              data : {
                config : routes
              }
            }).then(res => {
              Actions('http_request', {
                url : "/sainapse/configuration/ui_routes",
                method : "get",
                data : {}
              }).then(res => {
                sessionStorage.setItem('ui_routes', JSON.stringify(res.data.result.config))
                this.setState({...this.state, routes_loading : false, routes_loaded : true})
              }).catch(err => {
                sessionStorage.setItem('ui_routes', null)
                this.setState({...this.state, routes_loading : false, routes_loaded : false})
              })
            })
          }
        })
      })
    } 
  }

  getScreenRoutes = (config) => {
    let routes = []

    config.map(item => {
      if (item.type === 'screen') {
        routes.push(item)
      } else if (item.type === 'section') {
        let section_routes = this.getScreenRoutes(item.screens)
        routes.push(...section_routes)
      }
    })

    return routes
  }
  
  createDrawerRoutes = () => {
      let user_info = loadLoggedInUserInfo()
      let routes = []
      let drawer_routes = JSON.parse(sessionStorage.getItem('ui_routes')).drawer
      let screen_routes = this.getScreenRoutes(drawer_routes)
      console.log("Screen Routes : ", screen_routes)
      if (user_info) {
        screen_routes.forEach(route => {
          if (route.type === 'screen') {
            console.log("Creating Route : ", route.name)
            routes.push(
              <Route
                path = {route.route}
                exact
                render = {() => {
                  if (loadAuthToken()) {
                    if (isAuthorized(route.roles, user_info.roles)) {
                      return (
                        <Fragment>
                          <Screen key = {route.route} screen_name = {route.name} screen_comp = "test">
                            {React.createElement(Screens[route.component])}
                          </Screen>
                        </Fragment>
                      )
                    } else {
                      return (
                        <>
                          <AppToolBar></AppToolBar>
                          <PageNotAuthorized />
                        </>
                      );
                    }
                  } else {
                    console.log("Redirecting to Login from :", this.props.location)
                    // if (this.state.login_from === 'local') {
                    //   return (
                    //     <Redirect
                    //         to={{ pathname: "/login", state: { from: this.props.location }}}
                    //       />
                    //   )
                    // } else {
                    //   window.open(window.location.origin, "_self")
                    // }
                    // return (
                    //   <Redirect
                    //       to={{ pathname: "/signout_confirm", state: { from: this.props.location }}}
                    //     />
                    // )
                  }
                }}
              />
            )
          } else {
            route.screens.map(screen => {
              console.log("Creating Route : ", route.name)
              routes.push(
                <Route
                  path= {screen.route}
                  exact
                  render = {() => {
                    if (loadAuthToken()) {
                      if (isAuthorized(screen.roles, user_info.roles)) {
                        return (
                          <Fragment>
                            <Screen key = {route.route} screen_name = {screen.name} screen_comp = "test">
                              {React.createElement(Screens[screen.component])}
                            </Screen>
                          </Fragment>
                        )
                      } else {
                        return (
                          <>
                            <AppToolBar></AppToolBar>
                            <PageNotAuthorized />
                          </>
                        );
                      }
                    } else {
                      // if (this.state.login_from === 'local') {
                      //   return (
                      //     <Redirect
                      //         to={{ pathname: "/login", state: { from: this.props.location }}}
                      //       />
                      //   )
                      // } else {
                      //   localStorage.setItem("last_visited_url", window.location.href)
                      //   window.open(window.location.origin, "_self")
                      // }
                      // return (
                      //   <Redirect
                      //       to={{ pathname: "/signout_confirm", state: { from: this.props.location }}}
                      //     />
                      // )
                    }
                  }}
                />
              )
            })
          }
        })
      }
      return routes
  }

  createInternalRoutes = () => {
    let user_info = loadLoggedInUserInfo()
    console.log("User Info : ", user_info)
    let routes = []
    if (user_info) {
      let internal_routes = JSON.parse(sessionStorage.getItem('ui_routes')).internal
    internal_routes.map(route => {
      console.log("Creating Route : ", route)
      routes.push(
        <Route
          path = {route.route}
          exact
          render = {() => {
            if (loadAuthToken()) {
              if (isAuthorized(route.roles, user_info.roles)) {
                console.log("")
                return (
                  <Fragment>
                    {<Screen key = {route.route} screen_name = {route.name} screen_comp = "test">
                      {React.createElement(Screens[route.component])}
                    </Screen>}
                  </Fragment>
                )
              } else {
                return (
                  <>
                    <AppToolBar></AppToolBar>
                    <PageNotAuthorized />
                  </>
                );
              }
            } else {
              // if (this.state.login_from === 'local') {
              //   return (
              //     <Redirect
              //         to={{ pathname: "/login", state: { from: this.props.location }}}
              //       />
              //   )
              // } else {
              //   localStorage.setItem("last_visited_url", window.location.href)
              //   window.open(window.location.origin, "_self")
              // }

              // return (
              //   <Redirect
              //       to={{ pathname: "/signout_confirm", state: { from: this.props.location }}}
              //     />
              // )
            }
          }}
        />
      )
    })
    }
    
    return routes
  }

  create404Route = () => {
    return [(
      <Route
        component={() => (
          <>
            <AppToolBar></AppToolBar>
            <PageNotFound></PageNotFound>
          </>
        )}
      />
    )]
  }

  createRoutes = () => {
    console.log("Auth Token is : ", loadAuthToken())
    let user_info = loadLoggedInUserInfo()
    console.log("User Info is : ", loadLoggedInUserInfo())
    if (loadAuthToken()) {
      if (user_info) {
        console.log("Getting Privileges For : ", user_info)
        this.getUserPriveleges()
        if (this.state.routes_loaded === false) {
          console.log("Getting Routes")
          this.getUserPriveleges(() => this.getRoutes())
        } else {
          console.log("Creating Routes")
          return [...this.createDrawerRoutes(), ...this.createInternalRoutes()]
        }
      }
    } else {
      // if (this.state.login_from === 'local') {
      //   return (
      //     <Redirect
      //         to={{ pathname: "/login", state: { from: this.props.location }}}
      //       />
      //   )
      // } else {
      //   localStorage.setItem("last_visited_url", window.location.href)
      //   window.open(window.location.origin, "_self")
      // }
      return (
        <Redirect
            to={{ pathname: "/signout_confirm"}}
        />
      )
    }
  };


  fetchLoggedInUserInfo = (email, auth_type) => {
    console.log("Fetching User Info")
    this.setState({...this.state, user_info_loaded : false}, () => {
      Actions("http_request", {
        url: "/sainapse/user/" + email,
        method: "get",
        data : {}
        // data: {
        //   email : email,
        //   auth_type : auth_type
        // },
      })
      .then((response) => {
        let userInfo = response.data.result;
        //save email and roles to the local storage.
        let { email } = userInfo;
        // let roles = userInfo.user_roles.map(role => {
        //   return role.name
        // })
        this.props.dispatch({
          type: "UPDATE_LOGGED_IN_USER_INFO",
          payload: { email },
        });
        this.setState({...this.state, user_info_loaded : true}, () => {
            if (this.getUserPreference(JSON.parse(localStorage.getItem('logged_in_user_info'))) === null) {
              console.log("User Preferences Key Missing")
              this.createUserPreferences()
            } else if (this.getUserPreference(JSON.parse(localStorage.getItem('logged_in_user_info'))) === undefined) {
              console.log("User Preference for this user missing")
              this.createUserPreference(JSON.parse(localStorage.getItem('logged_in_user_info')))
            }
        })
      })
      .catch((err) => {
        console.log("error while fetching logged in user info", err);
      });
    })
  };

  handleAuth = (email, password, auth_type) => {
    Actions("http_request", {
      url: "/sainapse/sign_in",
      method: "post",
      data: {
        email: email,
        password: password,
        auth_type : auth_type
      },
    })
      .then((response) => {
        //read bearer-token from header, it is named as authorization in response header
        const { headers } = response;
        const { authorization } = headers;

        this.props.dispatch({
          type: "UPDATE_AUTH_TOKEN",
          payload: authorization,
        });
        // this.setState({
        //   invalidCredentials: false,
        // });

        let user_object = {
          email : response.data.result.user.email
        }

        this.props.dispatch({
          type: "UPDATE_LOGGED_IN_USER_INFO",
          payload: user_object,
        });

        sessionStorage.setItem('user_privileges', JSON.stringify(response.data.result.userPrivileges))

        this.setState({...this.state, user_info_loaded : true, invalidCredentials : false, invalidCredentialsErrorMessage : ""}, () => {
          if (this.getUserPreference(JSON.parse(localStorage.getItem('logged_in_user_info'))) === null) {
            console.log("User Preferences Key Missing")
            this.createUserPreferences()
          } else if (this.getUserPreference(JSON.parse(localStorage.getItem('logged_in_user_info'))) === undefined) {
            console.log("User Preference for this user missing")
            this.createUserPreference(JSON.parse(localStorage.getItem('logged_in_user_info')))
          }
        })
        //this.fetchLoggedInUserInfo(email, auth_type);
        window.open(localStorage.getItem('last_visited_url'), "_self")
      })
      .catch((err) => {
        console.log("login failed", err.response);
        this.setState({
          invalidCredentials: true,
          invalidCredentialsErrorMessage : err.response.data.message
        });
      });
  };


  appLogin = () => {
    //redirect to original if authenticated from login page.
    // let redirectTo = "/";
    const { from } = this.props.location.state || { from: { pathname: '/' } }
    console.log("From Source: ", from)
    return (
        <RouterSwitch>
          <Route
            path = '/login'
            render={() => {
              if (!loadAuthToken()) {
                return (
                  <Login
                    handleAuth={(email, password, auth_type) =>
                      this.handleAuth(email, password, auth_type)
                    }
                    invalidCredentials={this.state.invalidCredentials}
                    invalidCredentialsErrorMessage = {this.state.invalidCredentialsErrorMessage}
                    from = {this.state.source_path}
                  />
                );
              } else {
                if (loadLoggedInUserInfo()) {
                  return <Redirect to={from}></Redirect>;
                }
              }
            }}
          />
          <Route
            path = {"/signout_confirm"}
            exact
            render = {() => {
              return (
                <Fragment>
                  <SignOut/>
                </Fragment>
              )
            }}
          />
          {this.createRoutes()}
          {/* <Route
            path = {"/ifc"}
            exact
            render = {() => {
              return (
                <Fragment>
                  {<Screen key = {"ifc"} screen_name = {"ifc"} screen_comp = "test">
                    <IFC/>
                  </Screen>}
                </Fragment>
              )
            }}
          /> */}
          {/* <Route
            path = {"/irc"}
            exact
            render = {() => {
              return (
                <Fragment>
                  {<Screen key = {"irc"} screen_name = {"irc"} screen_comp = "test">
                    <IRC/>
                  </Screen>}
                </Fragment>
              )
            }}
          /> */}
        </RouterSwitch>
    );
  };

  renderFrame = () => {
    if (this.state.token_verified && !this.state.token_error) {
      return(
        <Fragment>
          {
            this.appLogin()
          }
          {!this.state.routes_loaded && loadAuthToken() && this.state.token_verified &&
            <div style = {{width : '100%', height : 'calc(100vh - 48px)', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
              <Paper style = {{width : '250px', height : '150px', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center', backgroundColor : '#3761BF'}} elevation = {4}>
                <div style = {{display : 'flex', flexDirection : 'column', alignItems : 'center'}}>
                  <img style = {{width : '150px', marginTop : '30px'}} src = {logo} alt = ""/>
                  <CircularProgress style = {{display : 'block', color : '#FFFFFF'}} variant = 'indeterminate' size = {20} color = 'primary'/>
                </div>
              </Paper>
            </div>  
          }
        </Fragment>
      )
    } else if (this.state.token_verified && this.state.token_error) {
      return(
        //  <ThemeProvider theme = {blue_theme}>
          <div style = {{width : '100%', height : 'calc(100vh - 48px)', display : 'flex', flexDirection : 'column', justifyContent : 'center', alignItems : 'center'}}>
            <Paper style = {{width : '250px', height : '150px', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center',  backgroundColor : '#3761BF'}} elevation = {4}>
              <div style = {{display : 'flex', flexDirection : 'column', alignItems : 'center'}}>
                <img style = {{width : '150px', marginTop : '30px'}} src = {logo} alt = ""/>
              </div>
            </Paper>
            <Typography style = {{marginTop : '10px'}} variant = 'h6'>Unable to authenticate.</Typography>
            <Typography variant = 'body2' color = 'secondary'>{"Sainapse Error Message :" + this.state.token_error_message}</Typography>
            <Typography style = {{cursor : 'pointer', marginTop : '20px'}} variant = "caption" color = "primary" onClick = {() => window.open(window.location.origin, "_self")}>Click here to try again.</Typography>
          </div> 
        //  </ThemeProvider> 
      )
    } else {
      return (
        <div style = {{width : '100%', height : 'calc(100vh - 48px)', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
          <Paper style = {{width : '250px', height : '150px', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center', backgroundColor : '#3761BF'}} elevation = {4}>
            <div style = {{display : 'flex', flexDirection : 'column', alignItems : 'center'}}>
              <img style = {{width : '150px', marginTop : '30px'}} src = {logo} alt = ""/>
              <CircularProgress style = {{display : 'block', color : '#FFFFFF'}} variant = 'indeterminate' size = {20} color = 'primary'/>
            </div>
          </Paper>
        </div>  
      )
    }
  }

  render() {
    const { classes } = this.props;

    return (
      <DndProvider backend = {HTML5Backend}>
          {this.renderFrame()}
      </DndProvider>
    );
  }
}

let mapStateToProps = (state) => {
  return {
    global_state: state,
    cur_screen: state.screen_state,
  };
};

export default withRouter(connect(mapStateToProps)(App));
